import { Component, OnInit } from '@angular/core';
import{ApiService} from '../../services/api.service';

@Component({
  selector: 'app-prestasi',
  templateUrl: './prestasi.page.html',
  styleUrls: ['./prestasi.page.scss'],
})
export class PrestasiPage implements OnInit {

  constructor(private api:ApiService) { }

  ngOnInit() {
  		this.getData(null);
  }

  page:any=1;
  moreData:boolean=true;
  dataPrestasi:any=[];
  loading:boolean;
  getData(ev)
  {
      this.loading=true;
  		var keyApp=localStorage.getItem('keyApp');
  		this.api.data('prestasi?page='+this.page+'&key_app='+keyApp,'get','').subscribe(data=>{
        this.loading=false;
  			this.parseDataPrestasi(data);
  			this.page=this.page+1;
  		})
  }
  parseDataPrestasi(data)
  {
  		for(var i=0;i<data.length;i++)
  		{
  			this.dataPrestasi.push(data[i]);
  		}
      
  }


}
